import { BrowserRouter as Router } from 'react-router-dom'
import { createRoot } from 'react-dom/client'
import App from '@/App'
import { ThemeProvider, StyledEngineProvider } from '@mui/material/styles'
import { MidmarkV5CompatTheme } from '@midmark-enterprise/shared-components'
import { UsersRegistrationServiceContext } from '@midmark/users-registration-service'
import { QueryClient, QueryClientProvider } from 'react-query'
import { UserVerificationServiceContext } from './services/UserVerificationService/UserVerificationService'
import { UserVerificationServiceApi } from './services/UserVerificationService/Implementations/UserVerificationServiceApi'
import { UsersRegistrationApiService } from '@midmark/users-registration-service/lib/service/implementations/UsersRegistrationApi.service'

const queryClient = new QueryClient()
const userVerificationApiService = new UserVerificationServiceApi()
const usersRegistrationApiService = new UsersRegistrationApiService(
    import.meta.env.VITE_APIM_URL +
        import.meta.env.VITE_USERSREGISTRATION_ROUTE,
    '0',
    import.meta.env.VITE_MIDMARK_API_SCOPE_BASE,
)

function mountApp() {
    const container = document.getElementById('root')
    if (!container) {
        throw new Error('Root element not found')
    }
    
    const root = createRoot(container as HTMLElement)

    root.render(
        <>
            <StyledEngineProvider injectFirst>
                <ThemeProvider theme={MidmarkV5CompatTheme}>
                    <QueryClientProvider client={queryClient}>
                        <UserVerificationServiceContext.Provider
                            value={userVerificationApiService}
                        >
                            <UsersRegistrationServiceContext.Provider
                                value={usersRegistrationApiService}
                            >
                                <Router>
                                    <App />
                                </Router>
                            </UsersRegistrationServiceContext.Provider>
                        </UserVerificationServiceContext.Provider>
                    </QueryClientProvider>
                </ThemeProvider>
            </StyledEngineProvider>
        </>,
    )
}

// Ensure DOM is ready before mounting React app
// This prevents React Error #299: "Target container is not a DOM element"
// which can occur when module scripts execute before DOM parsing completes
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mountApp)
} else {
    mountApp()
}
